import { connect } from 'react-redux'
import {
  logoutUser,
} from '../../../store/auth'
import {
  initChangePassword,
  changePassword,
} from '../../../store/password'
import ChangePassword from '../components/ChangePassword'

const mapDispatchToProps = {
  logoutUser,
  initChangePassword,
  changePassword,
}

const mapStateToProps = (state) => {
  const {
    currentUser,
  } = state.auth
  const {
    isChangePasswordLoading,
    isChangePasswordSuccess,
    changePasswordErrorMessage,
  } = state.password
  return {
    currentUser,
    isChangePasswordLoading,
    isChangePasswordSuccess,
    changePasswordErrorMessage,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword)



// WEBPACK FOOTER //
// ./src/routes/ChangePassword/containers/ChangePassword.js